
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 89.2 88.7","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#00AFAA"},attrs:{"d":"M56.1,27.8c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2C54.7,24.6,56.1,26,56.1,27.8"}}),_c('path',{staticStyle:{"fill":"#00AFAA"},attrs:{"d":"M69.5,80.6c-0.8,0-1.6-0.4-2.1-1c-0.8-1.1-0.6-2.7,0.5-3.6c10.1-7.4,16.1-19.2,16.1-31.7\n\tC84.1,22.7,66.4,5,44.6,5c-1.9,0-3.8,0.1-5.7,0.4l0,55.6c0,1.4-1.1,2.5-2.6,2.5c-1.4,0-2.6-1.1-2.6-2.5l0-57.8\n\tc0-1.2,0.9-2.3,2.1-2.5c2.9-0.6,5.8-0.9,8.8-0.9c24.6,0,44.6,19.9,44.6,44.4c0,14.1-6.8,27.5-18.2,35.8C70.5,80.5,70,80.6,69.5,80.6\n\t"}}),_c('path',{staticStyle:{"fill":"#00AFAA"},attrs:{"d":"M44.6,88.8C20,88.8,0,68.8,0,44.4C0,30.3,6.8,16.9,18.2,8.6C19.4,7.7,21,8,21.8,9.1c0.8,1.1,0.6,2.7-0.5,3.6\n\tC11.1,20,5.1,31.9,5.1,44.4c0,21.7,17.7,39.3,39.5,39.3c1.9,0,3.8-0.1,5.7-0.4l0-36.5c0-1.4,1.1-2.5,2.6-2.5c1.4,0,2.6,1.1,2.6,2.5\n\tl0,38.6c0,1.2-0.9,2.3-2.1,2.5C50.5,88.5,47.6,88.8,44.6,88.8"}})])
          )
        }
      }
    